import Api from 'libs/api';

class OwnersApi extends Api {
  constructor() {
    super('admin/owners');
  }

  getAccount = () => {
    return this.get('account');
  };
}

export default OwnersApi;
